import { appConfig } from '../config';

/**
 * Phase 6.5 switch: read data through the app's own server (/api, which
 * enforces each role's access) instead of straight from SharePoint.
 *  - 'build': VITE_DATA_VIA_API=true — everyone, always (from cutover on:
 *    the GitHub variable flips it; no tab can opt out, since direct
 *    SharePoint access is closed for non-admins then anyway);
 *  - 'tab': this browser tab opted in with ?api=1 (?api=0 opts out) — so
 *    the server path can be tried on the live site before cutover;
 *  - null: direct to SharePoint (today's default).
 * Never on without VITE_ENTRA_API_SCOPE. Reads, writes, offline sync and
 * photo/file uploads + downloads all go through it (steps 1–3). The tab flag is a UI preference, not
 * audit data, so sessionStorage is fine.
 */
export type ApiMode = 'build' | 'tab' | null;

const TAB_KEY = 'sspaudit.dataViaApi';
let resolved: { mode: ApiMode } | null = null;

export function apiMode(): ApiMode {
  if (resolved) return resolved.mode;
  let mode: ApiMode = null;
  if (appConfig.serverOnly) {
    mode = 'build';
  } else if (appConfig.apiScope) {
    try {
      const flag = new URLSearchParams(window.location.search).get('api');
      if (flag === '1' || flag === '0') sessionStorage.setItem(TAB_KEY, flag);
      const stored = sessionStorage.getItem(TAB_KEY);
      if (stored === '1') mode = 'tab';
      if (stored === '0') mode = null;
    } catch {
      // No window/storage (tests, locked-down browser): build default only.
    }
  }
  resolved = { mode };
  return mode;
}

export function dataViaApi(): boolean {
  return apiMode() !== null;
}
